const treeHighInMeter = 35;
const treeDiamaterInMeter = 0.5;
const treeDiameterinCentimeter = treeDiamaterInMeter * 100;
const pi = Math.PI;
const acht = 0.8;
const formfaktor = 0.45;
const baumVolumenNormaliesiertInKubikmeter = 1;
const umrechungsfaktorO2zuCO2 = 3.67;

// Darr Dichte nach Mail
const darrDichteNachBaumart = [
  { art: "Bergahorn", bereich: [530, 960] },
  { art: "Spitzahorn", bereich: [560, 810] },
  { art: "Birke", bereich: [510, 830] },
  { art: "Buche", bereich: [540, 910] },
  { art: "Douglasie", bereich: [350, 770] },
  { art: "Edelkastanie", bereich: [570, 660] },
  { art: "Eiche", bereich: [390, 930] },
  { art: "Elsbeere", bereich: [670, 900] },
  { art: "Erle", bereich: [490, 640] },
  { art: "Esche", bereich: [450, 860] },
  { art: "Fichte", bereich: [330, 470] },
  { art: "Hainbuche", bereich: [540, 860] },
  { art: "Wald-Kiefer", bereich: [330, 520] },
  { art: "Weymouth-Kiefer", bereich: [340, 510] },
  { art: "Kirschbaum", bereich: [490, 670] },
];

/**
 * Ermittelt die durchschnittliche Darrdichte für eine Baumart per Fuzzy-Match.
 * Fallback: 745 kg/m³ (Mittelwert Ahorn) wenn kein Match gefunden.
 * @param {string} treeType - Baumart-String, z.B. 'Stiel-Eiche' oder 'Quercus robur'
 * @returns {number} Darrdichte in kg/m³
 */
export function getDryDensity(treeType) {
  let singleWords = treeType.split(" ");
  let darrDichteTypeArray = new Array();
  let darrDichte = 0;
  let darrDichteAverageDivident = 0;

  darrDichteNachBaumart.forEach(function (currVal) {
    darrDichteTypeArray.push(currVal.art.toLowerCase());
  });

  singleWords.forEach(function (word) {
    word = word.toLowerCase();
    let regExOverall = new RegExp(word.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "i");

    if (word.length > 3) {
      darrDichteNachBaumart.forEach(function (darrDichteListEntry) {
        if (darrDichteListEntry.art.match(regExOverall)) {
          darrDichteAverageDivident = darrDichteAverageDivident + 1;
          darrDichte =
            darrDichte +
            (darrDichteListEntry.bereich[0] + darrDichteListEntry.bereich[1]) / 2;
        }
      });
    }
  });

  if (darrDichte == 0 || darrDichteAverageDivident == 0) {
    darrDichte = 745;
  } else {
    darrDichte = darrDichte / darrDichteAverageDivident;
  }

  return darrDichte;
}

/**
 * Calculates an Average over all DarrDichte in Array "darrDichteNachBaumart"
 * @returns {number} Average dry density in kg/m³ over all list entries
 */
export function getAverageDryDensity() {
  let sumOfAllDarrDichteAverage = 0;

  darrDichteNachBaumart.forEach(function (currVal) {
    let singleDarrDichteAverage = (currVal.bereich[0] + currVal.bereich[1]) / 2;
    sumOfAllDarrDichteAverage = sumOfAllDarrDichteAverage + singleDarrDichteAverage;
  });

  sumOfAllDarrDichteAverage = sumOfAllDarrDichteAverage / darrDichteNachBaumart.length;
  return sumOfAllDarrDichteAverage;
}

/**
 * Berechnet den CO2-Speicher eines Baums in Tonnen.
 * @param {number} [volume] - Holzvolumen in m³ (optional, Fallback: 1 m³)
 * @param {number} [dryDensity] - Darrdichte in kg/m³ (optional, Fallback: Listenmittelwert)
 * @returns {number} CO2-Speicher in Tonnen
 */
export function calculateTreeCo2Storage(volume, dryDensity) {
  let baumvolumen = baumVolumenNormaliesiertInKubikmeter;
  let darrDichte = getAverageDryDensity();

  if (volume) baumvolumen = volume;
  if (dryDensity) darrDichte = dryDensity;

  return (baumvolumen * (darrDichte / 2) * umrechungsfaktorO2zuCO2) / 1000;
}

/**
 * Schätzt das Holzvolumen nach der Uni-Münster-Formel: (π·d²/4 · h) / 2
 * @param {number} height - Baumhöhe in Metern
 * @param {number} diameter - Brusthöhendurchmesser in Metern
 * @returns {number} Geschätztes Holzvolumen in m³
 */
export function calculateTreeMassUniMuenster(height, diameter) {
  return (((pi * Math.pow(diameter, 2)) / 4) * height) / 2;
}

/**
 * Berechnet den CO2-Speicher eines Baums aus Höhe, Durchmesser und Baumart.
 * @param {number} height - Baumhöhe in Metern
 * @param {number} diameter - Brusthöhendurchmesser in Metern
 * @param {string} treeType - Baumart-String für Darrdichte-Lookup
 * @returns {number} CO2-Speicher in Tonnen
 */
export function calculateCo2StorageByDimensions(height, diameter, treeType) {
  let treeVolume = calculateTreeMassUniMuenster(height, diameter);
  return calculateTreeCo2Storage(treeVolume, getDryDensity(treeType));
}

/**
 * @param {number} circumference - Stammumfang in Metern
 * @returns {number} Durchmesser in Metern
 */
export function circumferenceToDiameter(circumference) {
  return circumference / pi;
}

/**
 * @param {number} cm
 * @returns {number} Wert in Metern
 */
export function cmToMeter(cm) {
  return cm / 100;
}

/**
 * @param {number} meter
 * @returns {number} Wert in Zentimetern
 */
export function meterToCm(meter) {
  return meter * 100;
}

/*
calculateTreeMassQuadratLacht();
calculateTreeMassCylinder();
calculateTreeMassVorratsfestmeter();
calculateTreeMassChatGPT();
calculateTreeMassLandwirtMediaCom();
*/
